import { Link } from 'react-router-dom'
import styles from './btnStyle.module.scss'

const ButtonCustom = ({
	variant = 'default', // Default variant in case none is provided
	to,
	size = 'md', // new prop: sm, md, lg
	type = 'button',
	onClick,
	className = '', // Default className as an empty string
	children,
	active = false,
	...rest
}) => {
	return (
		<>
			{to ? (
				<Link
					to={to}
					variant={variant} // Use the passed variant prop
					className={`${styles[variant] || ''} ${active && styles.active} ${className} ${styles[size] || ''}`}
					{...rest}
				>
					{children}
				</Link>
			) : (
				<button
					variant={variant} // Use the passed variant prop
					className={`${styles[variant] || ''} ${active && styles.active} ${className} ${styles[size] || ''}`} // Combine styles from SCSS and any extra className
					type={type}
					onClick={onClick}
					{...rest}
				>
					{children}
				</button>
			)}
		</>
	)
}

export default ButtonCustom
